import { Mutation } from 'app/types/mutation'
import { gql } from 'graphql-request'

export interface AcknowledgeUpgradeModalOutput extends Mutation {}

export const acknowledgeUpgradeModalMutation = () => gql`
  mutation acknowledgeUpgradeModal {
    acknowledgeUpgradeModal {
      success
      reason
    }
  }
`

export const acknowledgeUpgradeModalResult = (
  data: any
): AcknowledgeUpgradeModalOutput => {
  const { acknowledgeUpgradeModal } = data
  return {
    ...acknowledgeUpgradeModal,
  }
}
